import React from 'react';

function CategoryPillsRow({ subproductscategory, selectedCategory }) {
  return (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-center">
      {subproductscategory.map((category, index) => {
        const categoryName = category.category;
        return (
          <div
            key={index}
            className={`align-items-center cursor-pointer d-flex justify-content-between me-2 px-3 py-2 rounded-pill shadow_sm1 ${
              selectedCategory === categoryName
                ? 'active-category bg-primary text-white'
                : 'bg-light text-dark'
            }`}
            onClick={() => {
              window.location.hash = `#?category=${encodeURIComponent(
                categoryName
              )}`;
            }}
          >
            <span className="font_15 font_500">{categoryName}</span>
          </div>
        );
      })}
    </div>
  );
}

export default CategoryPillsRow;
